import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class UpdateActivityGroupCommand implements IMessage {
    id!: Guid;
    name!: string;

    public constructor(init?: Partial<UpdateActivityGroupCommand>) {
        Object.assign(this, init);
    }

    getMethod = () => "PUT";

    getUrl = () => `/admin/activity-groups/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => {
        return {
            name: this.name,
        };
    }
}